/**
 * Post-call WhatsApp hand-off (2026-10-15). When an agent submits a HOT or
 * WARM disposition, open WhatsApp to the buyer with an intro message pre-typed,
 * so the buyer has the agent's personal number saved for the follow-up.
 *
 * WhatsApp Web is opened IMMEDIATELY, inside the submit click — not after the save
 * request. Opening after an `await` loses the user gesture and the popup
 * blocker eats it; the first version also opened a blank tab and closed it
 * when the save failed, which in testing looked like "nothing happens".
 * The save and the WhatsApp tab are now independent.
 */

export const buildFollowUpWaUrl = (phone) => {
  const p10 = String(phone || '').replace(/\D/g, '').slice(-10);
  if (p10.length !== 10) return '';
  let agent = '';
  try { agent = (localStorage.getItem('name') || '').trim(); } catch (e) { /* storage blocked */ }
  const text =
    `Hello Sir/Ma'am, this is ${agent || 'your executive'} from Florida Beauty Labs.\n`
    + 'Nice talking to you! This is my personal number, you can contact me here anytime.\n\n'
    + 'Thank you for giving your important time';
  // Straight to WhatsApp Web — wa.me stops on an "Open app / Continue to
  // WhatsApp Web" chooser page first. Agents work on desktop WhatsApp Web.
  return `https://web.whatsapp.com/send?phone=91${p10}&text=${encodeURIComponent(text)}`;
};

// Call synchronously in the submit click. Opens WhatsApp right away when
// `enabled`. Returns no-op { go, cancel } so callers written against the
// earlier open-then-redirect version keep working unchanged.
export const preopenFollowUpWa = (phone, enabled) => {
  const url = enabled ? buildFollowUpWaUrl(phone) : '';
  if (enabled && !url) console.warn('[wa-followup] no valid buyer phone:', phone);
  if (url) {
    // Named target: every follow-up reuses ONE WhatsApp Web tab. WhatsApp Web
    // allows a single active tab, so a fresh tab per call would show "WhatsApp
    // is open in another window" in the older ones.
    const win = window.open(url, 'buyume_whatsapp_web');
    if (!win) console.warn('[wa-followup] popup blocked — allow pop-ups for this site');
  }
  return {
    go: () => {},
    cancel: () => {},
  };
};
